import { useLocalStorageState } from '@/utils/use-local-storage-state';

import { Banner } from './Banner';

const BLOB_STORAGE_WARNING_LAST_DISMISSED_KEY =
  'ls:blob-storage-warning-last-dismissed';

export function BlobStorageWarningBanner() {
  const [lastDismissed, setLastDismissed] = useLocalStorageState<string | null>(
    BLOB_STORAGE_WARNING_LAST_DISMISSED_KEY,
    null
  );

  // Check if a week has passed since last dismissal
  const shouldShowBanner = () => {
    if (!lastDismissed) {
      return true; // Never dismissed, show banner
    }

    const lastDismissedDate = new Date(lastDismissed);
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

    return lastDismissedDate < oneWeekAgo;
  };

  const handleDismiss = () => {
    setLastDismissed(new Date().toISOString());
  };

  if (!shouldShowBanner()) {
    return null;
  }

  return (
    <Banner
      open={true}
      intent="warning"
      title="Blob storage is not enabled on this LangSmith deployment"
      closeable={true}
      onClose={handleDismiss}
      description={
        <span>
          Blob storage can improve performance and reduce database size in high
          trace environments.{' '}
          <a
            href="https://docs.langchain.com/langsmith/self-host-blob-storage#enable-blob-storage"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:no-underline"
          >
            Learn how to enable blob storage
          </a>
        </span>
      }
    />
  );
}
